/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldSwitchSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldSwitchSmall',
      'aria-hidden': true,
      focusable: false,
      width:  16 * scale,
      height: 11 * scale,
      viewBox: '0 0 16 11',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M10.414 1H5.586C3.064 1 1 3.025 1 5.5S3.064 10 5.586 10h4.83C12.936 10 15 7.975 15 5.5S12.936 1 10.414 1M5.5 8a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5"}))
}
